export default __webpack_public_path__ + "static/TIMBERLINE-M-SERIES-26-C-front-WEB-931c5babfef907cc2cc0d87e2705219c.png";